<template lang="pug">
.benchmarks-panel.widget-common.d-flex.flex-column.flex-grow.pr-20
  .widget-title
    | {{ label }}
  .widget-body(:class="bodyClasses")
    template(v-if="panel && !loading")
      .widget-activity-item(
        v-for="item in visibleItems"
        :key="item.label"
      )
        .text-value
          span.arrow(v-if="item.arrow")
            img(:src="arrowIcon(item)")

          | {{ item.value }}
</template>

<script>
import { get } from 'lodash-es';

import { mapGetters, mapState } from 'vuex';
import { ACTIVITY_BENCHMARKS } from '~/app_constants';

export default {
  name: 'ActivitiesBenchmarksPanel',
  props: {
    panelKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['benchmarks']),
    visibleItems() {
      return this.panel && Object.fromEntries(Object.entries(this.panel.items).filter(([_, value]) => value.visible));
    },
    panel() {
      return get(this.benchmarks, this.panelKey);
    },
    label() {
      return ACTIVITY_BENCHMARKS[this.panelKey].label;
    },
    bodyClasses() {
      return this.loading ? 'widget-loading' : ' flex-grow align-items-center';
    },
  },
};
</script>
